import {
  LastCompletedVisitFilterValue,
  VisitCountFilterValue,
} from './_types';
import {
  VISIT_FILTER_OPERATORS,
  VisitFilterSelectOption,
} from './constants';

const operatorLabel = (operator?: string) =>
  VISIT_FILTER_OPERATORS.find((option) => option.value === operator)?.label || '';

const timeframeLabel = <T extends number>(
  timeframeDays: T | undefined,
  options: VisitFilterSelectOption<T>[]
) => options.find((option) => option.value === timeframeDays)?.label || '';

export const formatVisitCountFilterValue = (
  value: VisitCountFilterValue | null | undefined,
  timeframeOptions: VisitFilterSelectOption<number>[]
): string => {
  if (!value?.operator || value.value == null || !value.timeframeDays) {
    return '';
  }

  return `${operatorLabel(value.operator)} ${value.value} visits (${timeframeLabel(
    value.timeframeDays,
    timeframeOptions
  )})`;
};

export const formatLastCompletedVisitFilterValue = (
  value: LastCompletedVisitFilterValue | null | undefined,
  timeframeOptions: VisitFilterSelectOption<number>[]
): string => {
  if (!value?.operator || !value.timeframeDays) {
    return '';
  }

  return `${operatorLabel(value.operator)} ${timeframeLabel(
    value.timeframeDays,
    timeframeOptions
  )}`;
};
